<template>
  <div>
    <SelectList
      v-model="operationalTeam"
      dense
      emit-value
      label="Select Operational team"
      :option-label="(team) => teamLabel(team)"
      option-value="id"
      :options="operationalTeamOptions"
      :readonly="readonly"
      :rules="rules"
    />
  </div>
</template>

<script>
import { storeToRefs } from "pinia";

import SelectList from "src/components/common/SelectList.vue";
import { useUserStore } from "src/stores/user";

export default {
  name: "OperationalTeamSelector",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    organisation: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    operationalTeamOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const userStore = useUserStore();
    const { currentUser } = storeToRefs(userStore);

    return { currentUser };
  },
  computed: {
    operationalTeam: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    teamLabel(team) {
      if (!this.organisation.region) return team.name;

      return `${team.name} (${this.organisation.region.toUpperCase()})`;
    },
  },
};
</script>
